import { StateProvider, StateService, UrlService } from '@uirouter/angularjs';
import { RoleService } from './core/services/role/role.service';
import { AuthService } from './core/services/auth/auth.service';
import { ToastrService } from './core/services/toastr/toastr.service';
import { IQService } from 'angular';

export function appRoutesConfig( $urlServiceProvider: UrlService,
                                 $stateProvider: StateProvider ) {
  $urlServiceProvider.rules.otherwise('/');
  $stateProvider
    .state('app', {
      abstract: true,
      resolve: [
        {
          provide: 'APP_INIT',
          deps: [
            '$state',
            'AuthService',
            'RoleService',
            'ToastrService',
            '$q'
          ],
          useFactory: ( $state: StateService,
                        authService: AuthService,
                        roleService: RoleService,
                        toastrService: ToastrService,
                        $q: IQService ) => {
            return Promise.all([
              roleService.getRoles()
            ])
              .then(() => {
                return authService.loadUser()
                  .catch(( err ) => {
                    err.data = err.data || {};
                    const errText = err.data.text || 'User load failed';
                    toastrService.error(errText, 'Error');
                    return $state.go('logout');
                  });
              })
              .catch(( err ) => {
                console.log(err);
                toastrService.error('Unknown Error', 'Error');
                return $q.reject();
              });
          }
        }
      ]
    })
    .state('logout', {
      url: '/logout',
      resolve: [
        {
          provide: 'LOGOUT',
          deps: [
            'AuthService',
            '$state'
          ],
          useFactory: ( authService: AuthService,
                        $state: StateService ) => {
            return authService.logout()
              .then(() => {
                return $state.go('app.public.auth.login');
              });
          }
        }
      ]
    });
}

appRoutesConfig.$inject = [
  '$urlServiceProvider',
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/app-routing.ts